import "../../../assets/scss/components/sections/home/features-1.scss";
import { Col, Container, Image, Nav, Row } from "react-bootstrap";
import Heading from "../../templates/heading";

import feature1 from "../../../assets/images/home/feature-resume.png";
import feature2 from "../../../assets/images/home/feature-cover.png";
import feature3 from "../../../assets/images/home/feature-interview.png";
import { useState } from "react";
import shape1 from "../../../assets/images/home/shape-2.svg";
import shape2 from "../../../assets/images/home/shape-3.svg";

const Features1 = () => {
  const [activePlan, setActivePlan] = useState("Resume");

  const data = {
    Resume: {
      title: "AI-Tailored Resumes",
      description:
        "Our AI Resume Builder creates a standout, ATS-friendly, tailored resume customized for each position within seconds",
      image: feature1,
    },
    "Cover Letter": {
      title: "Personalized Cover Letters",
      description:
        "Generate a personalized cover letter that complements your resume and highlights your unique skills and experiences",
      image: feature2,
    },
    "Mock Interview": {
      title: "Mock Interviews",
      description:
        "Get AI-driven guidance to ace your interviews and land your dream job with confidence",
      image: feature3,
    },
  };

  const currentData = data[activePlan];

  return (
    <div className="features-1-section" id="features">
      <Container>
        <div className="features-1">
          <Heading
            heading="Streamline your job search"
            text="Create tailored resumes and cover letters and prepare for job interviews"
          />
          <div className="feature-1-switch-buttons text-center mb-4">
            {["Resume", "Cover Letter", "Mock Interview"].map((plan) => (
              <button
                key={plan}
                className={`filter-btn ${activePlan === plan ? "active" : ""}`}
                onClick={() => setActivePlan(plan)}
              >
                {plan}
              </button>
            ))}
          </div>
          <div className="content">
            <Row>
              <Col lg={6}>
                <div className="left-content">
                  <h3 className="heading-3">{currentData.title}</h3>
                  <p className="paragraph-small-regular">
                    {currentData.description}
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="right-content">
                  <div className="image">
                    <Image src={currentData.image} />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
      <div className="shape-1 shape">
        <Image src={shape1} />
      </div>
      <div className="shape-2 shape">
        <Image src={shape2} />
      </div>
    </div>
  );
};

export default Features1;
